var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8.35066C7.00074 8.71049 6.70983 9.00289 6.35 9.004H1.15C0.977143 9.00364 0.811513 8.93459 0.689595 8.81205C0.567677 8.68951 0.499472 8.52352 0.500003 8.35066V1.15733C0.499649 0.98441 0.568003 0.81843 0.690026 0.695907C0.81205 0.573383 0.977748 0.504351 1.15067 0.503998L6.35067 0.512664C6.71024 0.514134 7.00074 0.806427 7 1.166V8.35066Z",
    stroke: "#C9E8FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4973 4.36268C15.4947 4.7192 15.2038 5.00623 14.8473 5.00401H9.64731C9.47605 5.00526 9.31131 4.93836 9.18939 4.81807C9.06747 4.69778 8.99837 4.53395 8.99731 4.36268V1.15402C8.99952 0.797866 9.28983 0.510835 9.64598 0.512682L14.846 0.504015C15.2029 0.501428 15.4944 0.788462 15.4973 1.14535V4.36268Z",
    stroke: "#C9E8FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14.8607C6.99894 15.0324 6.92973 15.1966 6.80758 15.3172C6.68543 15.4379 6.52035 15.5051 6.34867 15.504L1.14867 15.4953C0.792149 15.4968 0.501837 15.2092 0.5 14.8527V11.6467C0.500881 11.4752 0.569881 11.3112 0.691799 11.1906C0.813718 11.0701 0.978554 11.0029 1.15 11.004H6.35C6.70689 11.0022 6.9978 11.2898 7 11.6467V14.8607Z",
    stroke: "#C9E8FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64798 15.504C9.47495 15.5036 9.30915 15.4345 9.1871 15.3119C9.06506 15.1892 8.99679 15.023 8.99732 14.85V7.658C8.99679 7.48508 9.06497 7.31903 9.18687 7.19638C9.30877 7.07373 9.4744 7.00453 9.64732 7.004H14.8473C15.0202 7.00453 15.1859 7.07373 15.3078 7.19638C15.4297 7.31903 15.4978 7.48508 15.4973 7.658V14.8413C15.4981 15.201 15.2077 15.4935 14.848 15.4953L9.64798 15.504Z",
    stroke: "#C9E8FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboard);
export default __webpack_public_path__ + "static/media/ic-dashboard.4079a9651ee51070d9f70cd3ff508959.svg";
export { ForwardRef as ReactComponent };